/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { useSimpliCity } from "cms/hooks/use-simplicity";
import { useMemo } from "react";

const scrollTargetComponents = [
    { componentType: "component.rich-text", title: "About us" },
    { componentType: "component.process-cards", title: "Adjudication" },
    { componentType: "component.data-table", title: "Upcoming adjudication hearings", sectionLinkHeading: "Review upcoming hearings" },
    { componentType: "component.heading", title: "Additional evidence", sectionLinkHeading: "Submit additional evidence" },
    { componentType: "component.contact-card", title: "Contact", sectionLinkHeading: "Get answers to your questions" },
];

const useScrollTargets = () => {
    const { model } = useSimpliCity();
    const fields = model?.fields;
    const bodyField = fields?.find((field) => field.name === "body");
    const values = bodyField?.values;
    const components = values && values.length > 0 && values[0].value;

    const scrollTargets = useMemo(() => {
        const navLinks = [];
        for (let scrollTargetComponent of scrollTargetComponents) {
            const { componentType, title, sectionLinkHeading } = scrollTargetComponent;
            const component = components?.find((component) => component.type === componentType);
            if (component) {
                const guid = component?.guid;
                const componentId = `field-component-${guid}`;
                navLinks.push({
                    id: componentId,
                    title,
                    sectionLinkHeading
                });
            }
        }
        return navLinks;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [components]);

    return scrollTargets;
};

export { useScrollTargets };
